import Toast, { useToast } from "vue-toastification";
import "vue-toastification/dist/index.css";
import { Ref, unref } from "vue";
import { RefOrString } from "@/types/BaseTypes";

const options = {};
export { Toast, options };

export type ToastType = "info" | "success" | "error" | "warning";

const notification = useToast();
/**
 * notify any text
 * @param {string} text text
 * @param {ToastType} type message type
 * @param delay
 */
const setNotification = (text: RefOrString, type: ToastType = "info", delay = 4000) => {
  return notification[type](unref(text), {
    timeout: delay
  });
};

/**
 * notify error
 * @param {RefOrString} text
 * @param {number} delay время до пропадания оповещения
 */
export const notifyError = (text: RefOrString = "", delay = 4000) =>
  setNotification(text, "error", delay);

/**
 * notify Success
 * @param {RefOrString} text
 * @param {number} delay время до пропадания оповещения
 */
export const notifySuccess = (text: RefOrString = "", delay = 4000) =>
  setNotification(text, "success", delay);

/**
 * notify Info
 * @param {RefOrString} text
 * @param {number} delay время до пропадания оповещения
 */
export const notifyInfo = (text: RefOrString = "", delay = 4000) =>
  setNotification(text, "info", delay);


/**
 * notify Warning
 * @param {RefOrString} text
 * @param {number} delay время до пропадания оповещения
 */
export const notifyWarning = (text: RefOrString = "", delay = 4000) =>
  setNotification(text, "warning", delay);
